import { type FetchLike, type Middleware, type WretchOptions } from 'wretch';
import { requestSink } from '../request-sink';

// Same as sinkInterceptor, but for fetch requests (non-gRPC)
export const sinkMiddleware: Middleware = () => (next: FetchLike) => (url: string, opts: WretchOptions) =>
  requestSink.pipe(() => next(url, opts));
